var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 47,
    viewBox: "0 0 57 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 46,
    rx: 7.5,
    fill: "#2FA551"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 46,
    rx: 7.5,
    stroke: "#2FA551"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0395 30.216C21.8275 30.216 20.7535 29.946 19.8175 29.406C18.8935 28.854 18.1675 28.092 17.6395 27.12C17.1235 26.136 16.8655 24.996 16.8655 23.7C16.8655 22.416 17.1235 21.288 17.6395 20.316C18.1675 19.332 18.8935 18.564 19.8175 18.012C20.7535 17.46 21.8275 17.184 23.0395 17.184C24.2875 17.184 25.3735 17.46 26.2975 18.012C27.2335 18.564 27.9535 19.332 28.4575 20.316C28.9735 21.288 29.2315 22.416 29.2315 23.7C29.2315 24.996 28.9735 26.136 28.4575 27.12C27.9535 28.092 27.2335 28.854 26.2975 29.406C25.3735 29.946 24.2875 30.216 23.0395 30.216ZM23.0575 28.614C23.9215 28.614 24.6775 28.416 25.3255 28.02C25.9855 27.624 26.4955 27.06 26.8555 26.328C27.2155 25.596 27.3955 24.72 27.3955 23.7C27.3955 22.68 27.2155 21.804 26.8555 21.072C26.4955 20.34 25.9855 19.782 25.3255 19.398C24.6775 19.002 23.9215 18.804 23.0575 18.804C22.1815 18.804 21.4135 19.002 20.7535 19.398C20.1055 19.782 19.6015 20.34 19.2415 21.072C18.8815 21.804 18.7015 22.68 18.7015 23.7C18.7015 24.72 18.8815 25.596 19.2415 26.328C19.6015 27.06 20.1055 27.624 20.7535 28.02C21.4135 28.416 22.1815 28.614 23.0575 28.614ZM31.378 30V17.4H33.178V22.872L38.218 17.4H40.468L35.806 22.404L40.558 30H38.38L34.528 23.808L33.178 25.23V30H31.378Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkk);
export default __webpack_public_path__ + "static/media/okk.aba4d709956bd64a1652d405f3585c65.svg";
export { ForwardRef as ReactComponent };